<template>
  <div>
    
    <Row style="width: 100%;margin-top:110px">
      <Col span="24" class="backImg">
            <img :src="img" width="100%" style="vertical-align: bottom;">
      </Col>
    </Row>
   
   

   <Row style="width: 100%;margin-top: 50px;">
      <Col span="24">
            
            <span style="font-size: 28px;">{{info.title}}</span></br></br>
            <span style="font-size: 18px;margin-left:80px">{{info.shortTitle}}</span></br>
      </Col>
    </Row>
    

     <Row style="display: flex;justify-content: center;margin-top:50px">
      <Col span="24" style="    min-height: 200px;
                                border-bottom: #3339 solid 1px;
                                font-size: 18px;text-align:left;text-indent:2em;
                                line-height: 32px;width:1560px;">
            <p style="font-size: 18px;text-align:right;">{{info.author}}{{info.releaseTime}}</p></br>
            <p >{{info.attrTxt}}</p></br></br>
      </Col>
    </Row>
    
</br>
    <Row style="width: 80%;margin-top: 10px;margin-left: 170px;">
      
      <Col span="24">
           <div class="turnList" style="text-align:left;letter-spacing: 2px;">
                <a href="/newsData"><span style="color: #5645f7;font-size:20px;text-align:left;letter-spacing: 2px;">|返回列表|</span></a><br/><br/>
                <span @click="getLastM()">上一篇：{{lastNewsInfo.title}}</span><br/>
                <span @click="getNextM()">下一篇：{{nextNewsInfo.title}}</span><br/><br/><br/>
            </div>
      </Col>
    </Row>
  </div>
 
</template>
<script>
export default {
  data() {
    return {
      "id":"",
      "title":"",
      "shortTitle":"",
      "attrTxt":"",
      "views":"",
      "author":"",
      "releaseTime":"", 
      info:{
      },
      isOk:false,
      // info1:{},
      nextNewsInfo:{},
      lastNewsInfo:{},
      carouselImg:[
        {src: "../../../../static/15.jpg",href: "www.baidu.com"},
        {src: "../../../../static/220.jpg",href: "www.baidu.com"},
        {src: "../../../../static/221.jpg",href: "www.baidu.com"},
        {src: "../../../../static/22.jpg",href: "www.baidu.com"}
      ],
      img: "../../../../static/officeImg/mediaInformation/banner.png",
      img2:"../../../../static/officeImg/index/areaGas.png",
      img3:"../../../../static/officeImg/index/areacar.png",
      img4:"../../../../static/officeImg/index/areaSound.png",
     
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    this.loadData();
    
  },
  created(){
    // console.log(this.$route.query.info);
    this.info = this.$route.query.info;
    // alert(this.info);
    // console.log(this.$route.query.lastNewsInfo);

      // if(this.$route.query.lastNewsInfo!=null){

      //   alert("123");
      // }else{
      //   this.info = this.$route.query.info;
      // }
     
      
      // if(this.isOk){
      //  this.lastNewsInfo = this.$route.query.lastNewsInfo;
      //  this.info = this.lastNewsInfo;
      // console.log(this.lastNewsInfo);
      // }
      
    },
  methods: {
    loadData: function() {
      this.lastNews();
      this.nextNews();
      this.viewAdd();
      
    },
    getLastM(){
      if(this.nextNewsInfo.title == "没有上一篇啦"){
        return;
      }
      this.info = this.lastNewsInfo;
      
      this.lastNews();
      this.nextNews();

    },

    getNextM(){
      // alert("获取下一篇")
     console.log(this.nextNewsInfo);
      
      if(this.nextNewsInfo.title == "没有下一篇啦"){
        return;
      }
      this.info = this.nextNewsInfo;
      this.nextNews();
      this.lastNews();
     

    },
   
    lastNews(){
        var id = this.info.id;
        var channelId = this.info.channelId;
        protocol.param_lastNews.data={
          id : id,
          channelId : channelId
        }
        http.post(protocol.param_lastNews).then(res =>{
          let{code,msg,lastNews}=res.data;
            this.lastNewsInfo=lastNews;
          if(this.lastNewsInfo == null){
            this.lastNewsInfo = {title:"没有上一篇啦"};
          }
         
         
        });
    },
    nextNews(){
        var id = this.info.id;
        var channelId = this.info.channelId;
        protocol.param_nextNews.data={
          id : id,
          channelId : channelId
        }
        http.post(protocol.param_nextNews).then(res =>{
          let{code,msg,nextNews}=res.data;
            this.nextNewsInfo=nextNews;
            if(this.nextNewsInfo == null){
            this.nextNewsInfo = {title:"没有下一篇啦"};
          }
          
         
         
        });
    },
    viewAdd(){
      
        var id = this.info.id;
        var title = this.info.title;
       
        protocol.param_addViews.data={
          id : id
        }
        http.get(protocol.param_addViews).then(res =>{
          // alert("chengongla ");
        });
      }
     

    
    

  }
};
</script>
<style scoped>
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.imgCss{
  line-height: 50px; font-size: 20px; background: rgb(86, 69, 247) none repeat scroll 0% 0%; margin: 0px; color: white;height: 50px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}
</style>



// WEBPACK FOOTER //
// src/views/newsDataDetails/newsDataDetails.vue